import { render } from "./Employment.vue?vue&type=template&id=5ee77739&scoped=true"
import script from "./Employment.vue?vue&type=script&lang=js"
export * from "./Employment.vue?vue&type=script&lang=js"

import "./Employment.vue?vue&type=style&index=0&id=5ee77739&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee77739"]])

export default __exports__